



import Vue from "vue";
import ExpansionPanels from "@/components/ExpansionPanels.vue";
import chat from "./../assets/data/account/chat.json";

export default Vue.extend({
  name: "Chat",
  components: {
    ExpansionPanels,
  },
  data() {
    return {
      chatData: chat,
    };
  },
});
